import { Injectable } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, tap } from 'rxjs';
import { AlertTypes } from '../models/alertTypes';
import { AlertTypesState } from '../store/state/alert-types.state';
import { DTCDescription } from '../models/dtcDescription';

@Injectable({
  providedIn: 'root'
})
export class FaultDescritpionService {


  @Select(AlertTypesState.getAlertTypes) getAlertTypes$: Observable<AlertTypes>;
  private faultDescriptions: AlertTypes;

  constructor() {
    this.getAlertTypes$
      .pipe(
        tap(alertTypes => this.faultDescriptions = alertTypes),
      ).subscribe();
  }

  public getDescriptions(protocol: string, controller: number, faultCode: number, failureMode: number, faultType: string, faultCodeId: string = "", groupId: string = ""): DTCDescription {
    let faultCodeDesc = "";
    let failureModeDesc = "";
    let controllerDesc = "";

    if(faultCodeId.length > 0) {
      faultCodeDesc = this.faultDescriptions.faultcodes.find(fault => fault.id === faultCodeId)?.name ?? "";
    } else {
      let faultCodes = this.faultDescriptions.faultcodes.filter(
        fault => fault.protocol === protocol &&
          fault.sourceAddress === controller &&
          fault.code === faultCode &&
          fault.id === faultCodeId &&
          fault.faultType === faultType);

      if (faultCodes?.length > 0) {
        faultCodeDesc = faultCodes[0].name;
      }
      else {
        faultCodes = this.faultDescriptions.faultcodes.filter(
          code => code.protocol === protocol &&
            code.sourceAddress === -1 &&
            code.code === faultCode &&
            code.groupId === groupId &&
            code.faultType === faultType);

        if (faultCodes.length > 0) {
          faultCodeDesc = faultCodes[0].name;
        }
      }
  }

    const failureCodes = this.faultDescriptions.failuremodes.filter(
      fault => fault.protocol === protocol &&
        fault.code === failureMode);

    if (failureCodes?.length > 0) {
      if (failureCodes[0]) {
        failureModeDesc = failureCodes[0].name;
      }
    }

    const controllerCodes = this.faultDescriptions.controllers.filter(
      fault => fault.protocol === protocol &&
        fault.code === controller);

    if (controllerCodes?.length > 0) {
      controllerDesc = controllerCodes[0].name;
    }

    return {
      controllerDescription: controllerDesc,
      faultCodeDescription: faultCodeDesc,
      failureModeDescription: failureModeDesc
    } as DTCDescription;
  }

}
